document.addEventListener('DOMContentLoaded', () => {
  if (typeof Fancybox === 'undefined') return;

  function initThumbVideos() {
    document.querySelectorAll('.product-thumb-video').forEach(v => {
      v.muted = true;
      v.play().catch(() => {});
    });
  }
  initThumbVideos();

  function buildGallery() {
    const items = [];
    document.querySelectorAll('.product-media-container').forEach(container => {
      const iframeEl = container.querySelector('[data-fancybox="gallery"][data-type="iframe"]');
      if (iframeEl) {
        items.push({ type: 'iframe', src: iframeEl.getAttribute('data-src') });
        return;
      }
      const imgEl = container.querySelector('[data-fancybox="gallery"]:not([data-type])');
      if (imgEl) {
        items.push({ type: 'image', src: imgEl.src });
        return;
      }
      const videoWrap = container.querySelector('.product-video-thumb-wrap');
      if (videoWrap) {
        const targetId = videoWrap.getAttribute('data-video-target');
        if (targetId) {
          items.push({ type: 'inline', src: `#${targetId}` });
          return;
        }
        const thumbVideo = videoWrap.querySelector('video');
        const poster = videoWrap.getAttribute('data-poster') || thumbVideo?.getAttribute('poster') || '';
        let sources = [];
        try {
          const raw = videoWrap.getAttribute('data-sources');
          if (raw) sources = JSON.parse(raw);
        } catch (e) {}
        if (!Array.isArray(sources) || !sources.length) {
          sources = Array.from(thumbVideo?.querySelectorAll('source') || [])
            .map(s => ({ url: s.getAttribute('src'), type: s.getAttribute('type') || 'video/mp4' }))
            .filter(s => s.url);
        }
        const sourceTags = sources.map(s => `<source src="${s.url}" type="${s.type}">`).join('');
        const videoHtml = `
          <div style="line-height:0;background:#000;">
            <video autoplay muted playsinline poster="${poster}"
              style="width:100vw;max-width:100%;max-height:85vh;display:block;margin:auto;">
              ${sourceTags}
            </video>
          </div>`;
        items.push({ type: 'html', src: videoHtml });
      }
    });
    return items;
  }

  function injectControls(fancybox) {
    document.querySelector('.fancybox-controls')?.remove();
    const controls = document.createElement('div');
    controls.className = 'fancybox-controls';
    controls.innerHTML = `
      <button class="fancy-prev navBtn" title="Previous">
        <svg fill="none" width="16" viewBox="0 0 16 18" aria-hidden="true">
          <path d="M11 1 3 9l8 8" stroke="currentColor" stroke-linecap="square"/>
        </svg>
      </button>
      <button class="fancy-close" title="Close">
        <svg width="20" height="20" viewBox="0 0 24 24">
          <path d="M6 6L18 18M6 18L18 6"></path>
        </svg>
      </button>
      <button class="fancy-next navBtn" title="Next">
        <svg fill="none" width="16" viewBox="0 0 16 18" aria-hidden="true">
          <path d="m5 17 8-8-8-8" stroke="currentColor" stroke-linecap="square"/>
        </svg>
      </button>
    `;
    fancybox.container.appendChild(controls);
    controls.querySelector('.fancy-close').addEventListener('click', () => fancybox.close());
    controls.querySelector('.fancy-next').addEventListener('click', () => fancybox.next());
    controls.querySelector('.fancy-prev').addEventListener('click', () => fancybox.prev());
  }

  const isFancyboxInDOM = () => !!document.querySelector('.fancybox__container');

  function bindVideoEvents(video) {
    if (video._fbBound) return;
    video._fbBound = true;

    video.addEventListener('ended', () => {
      if (!isFancyboxInDOM() || video._fbStopped) return;
      video._fbActive = false;
      video.currentTime = 0;
      video.muted = true;
      playVideo(video);
    });

    video.addEventListener('pause', () => {
      if (!isFancyboxInDOM() || video._fbStopped) return;
      setTimeout(() => {
        if (!isFancyboxInDOM() || video._fbStopped || !video.paused) return;
        video._fbActive = false;
        playVideo(video);
      }, 300);
    });
  }

  function playVideo(video) {
    if (!video || video._fbActive || video._fbStopped) return;
    if (!isFancyboxInDOM()) return;
    video._fbActive = true;
    video.muted = true;
    video.playsInline = true;
    video.setAttribute('playsinline', '');

    const doPlay = () => {
      if (!isFancyboxInDOM() || video._fbStopped) return;
      video.play().catch(() => {});
    };

    if (video.readyState >= 2) {
      doPlay();
    } else {
      if (video.readyState === 0) {
        try { video.load(); } catch(e) {}
      }
      video.addEventListener('canplay', () => {
        if (!isFancyboxInDOM() || video._fbStopped) return;
        doPlay();
      }, { once: true });
    }

    bindVideoEvents(video);
  }

  function activateSlideVideo(slideEl) {
    if (!slideEl) return;
    const video = slideEl.querySelector('video');
    if (video) {
      playVideo(video);
      return;
    }
    let tries = 0;
    const timer = setInterval(() => {
      if (!isFancyboxInDOM()) { clearInterval(timer); return; }
      const v = slideEl.querySelector('video');
      if (v) {
        clearInterval(timer);
        playVideo(v);
      } else if (++tries >= 30) {
        clearInterval(timer);
      }
    }, 100);
  }

  function deactivateSlideVideo(slideEl) {
    if (!slideEl) return;
    const video = slideEl.querySelector('video');
    if (!video) return;
    video._fbStopped = true;
    video._fbActive = false;
    video.pause();
    video.currentTime = 0;
    video.muted = true;
  }

  function resetVideo(video) {
    if (!video) return;
    video._fbActive = false;
    video._fbStopped = false;
    video._fbBound = false;
  }

  function openFancybox(startIndex = 0) {
    const gallery = buildGallery();
    if (!gallery.length) return;

    document.querySelectorAll('.product-media-container video').forEach(resetVideo);

    Fancybox.show(gallery, {
      startIndex: Math.min(startIndex, gallery.length - 1),
      Hash: false,
      Thumbs: false,
      compact: false,
      contentClick: 'toggleCover',
      wheel: 'slide',
      showClass: 'f-zoomInRight',
      hideClass: 'f-zoomOutLeft',
      Toolbar: false,
      Images: {
        Panzoom: {
          panMode: 'mousemove',
          mouseMoveFactor: 1.1,
          mouseMoveFriction: 0.12,
        },
      },
      on: {
        ready(fancybox) {
          injectControls(fancybox);
        },
        reveal(fancybox, slide) {
          if (slide.el) activateSlideVideo(slide.el);
        },
        'Carousel.change'(fancybox, carousel, to, from) {
          if (from != null && fancybox.slides?.[from]?.el) {
            deactivateSlideVideo(fancybox.slides[from].el);
          }
          if (fancybox.slides?.[to]?.el) {
            const v = fancybox.slides[to].el.querySelector('video');
            if (v) { v._fbActive = false; v._fbStopped = false; }
            activateSlideVideo(fancybox.slides[to].el);
          }
        },
        destroy() {
          document.querySelector('.fancybox-controls')?.remove();
          initThumbVideos();
        },
      },
    });
  }

  const containers = Array.from(document.querySelectorAll('.product-media-container'));
  containers.forEach((container, idx) => {
    const imgEl = container.querySelector('[data-fancybox="gallery"]:not([data-type="iframe"])');
    if (imgEl) {
      imgEl.style.cursor = 'pointer';
      imgEl.addEventListener('click', e => {
        e.preventDefault();
        e.stopImmediatePropagation();
        openFancybox(idx);
      });
    }
    const videoWrap = container.querySelector('.product-video-thumb-wrap');
    if (videoWrap) {
      videoWrap.addEventListener('click', e => {
        e.preventDefault();
        e.stopImmediatePropagation();
        openFancybox(idx);
      });
    }
  });
});
